import React, {  useState } from 'react';
import { useSelector} from 'react-redux';


/**
 * @file
 * @module Components/AdminCreateUser
 * @description AdminCreateUser est un composant permettant à un administrateur de créer un utilisateur.
 * 
 */




const apiPrefix = process.env.REACT_APP_API_PREFIX;

export default function AdminCreateUser() {
    const [username, setUsername] = useState('');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [company, setCompany] = useState('');
    const [siret, setSiret] = useState('');
    const [chefEntreprise, setChefEntreprise] = useState(false);
    const [active, setActive] = useState(true);
    const [error, setError] = useState(null);
    const [usernameError, setUsernameError] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const regexEmail = /^[^@\s]{2,30}@[^\s@]{2,30}\.[^@\s]{2,}$/;
    const token = useSelector((state) => state.user.token);

    const hide = () => {
        setShowModal(false);
        window.location.reload();
    };

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
        if (!regexEmail.test(e.target.value)) {
            setUsernameError("Le nom d'utilisateur doit être une adresse e-mail valide.");
        } else {
            setUsernameError('');
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!regexEmail.test(username)) {
            setError("Le nom d'utilisateur doit être une adresse e-mail valide.");
            return;
        }
        if (!company.trim() || !siret.trim()) {
            setError("Le nom de société et le SIRET sont obligatoires.");
            return;
        }

        const [password] = 'p';

        const formData = {
            username,
            firstname,
            password,
            lastname,
            company,
            siret,
            chefEntreprise,
            active
        };
//console.log(formData);

        try {
            const response = await fetch(apiPrefix+'register', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Inscription réussie !');
                setShowModal(true);
                setIsModalOpen(false);
            } else if (response.status === 502) {
                setError("Un compte existe déjà avec cette adresse e-mail.");
            } else if (response.status === 400) {
                const data = await response.json().catch(() => ({}));
                setError(data.error || "Le nom de société et le SIRET sont obligatoires.");
            } else {
                console.error('Erreur lors de l\'inscription:', response.statusText);
                setError("Erreur lors de l'inscription. Veuillez réessayer.");
            }
        } catch (error) {
            console.error('Erreur lors de la tentative d\'inscription:', error);
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target.className === 'modal-overlay') {
            setIsModalOpen(false);
        }
    };

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)}
                className="btn-primary"
            >
                <i className="fas fa-user-plus mr-2"></i>
                Créer un utilisateur
            </button>

            {isModalOpen && (
                <div className="modal-overlay" onClick={handleOverlayClick}>
                    <div className="modal-content">
                        <button 
                            className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
                            onClick={() => setIsModalOpen(false)}
                        >
                            ×
                        </button>
                        
                        <h2 className="text-2xl font-bold text-primary mb-6">Créer un utilisateur</h2>
                        
                        <form onSubmit={handleSubmit} className="space-y-4">
                            {error && <div className="alert alert-error">{error}</div>}
                            
                            <div className="form-group">
                                <label htmlFor="username" className="form-label">
                                    <i className="fas fa-envelope mr-2.5 text-primary"></i>
                                    Email :
                                </label>
                                <input
                                    type="text"
                                    id="username"
                                    value={username}
                                    onChange={handleUsernameChange}
                                    required
                                    className="form-input"
                                />
                                {usernameError && <div className="form-error">{usernameError}</div>}
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="firstname" className="form-label">
                                    <i className="fas fa-user mr-2.5 text-primary"></i>
                                    Prénom :
                                </label>
                                <input
                                    type="text"
                                    id="firstname"
                                    value={firstname}
                                    onChange={(e) => setFirstname(e.target.value)}
                                    required
                                    className="form-input"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="lastname" className="form-label">
                                    <i className="fas fa-user mr-2.5 text-primary"></i>
                                    Nom de famille :
                                </label>
                                <input
                                    type="text"
                                    id="lastname"
                                    value={lastname}
                                    onChange={(e) => setLastname(e.target.value)}
                                    required
                                    className="form-input"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="company" className="form-label">
                                    <i className="fas fa-building mr-2.5 text-primary"></i>
                                    Entreprise :
                                </label>
                                <input
                                    type="text"
                                    id="company"
                                    value={company}
                                    onChange={(e) => setCompany(e.target.value)}
                                    required
                                    className="form-input"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="siret" className="form-label">
                                    <i className="fas fa-hashtag mr-2.5 text-primary"></i>
                                    SIRET :
                                </label>
                                <input
                                    type="text"
                                    id="siret"
                                    value={siret}
                                    onChange={(e) => setSiret(e.target.value)}
                                    required
                                    className="form-input"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="chefEntreprise" className="form-label">
                                    <i className="fas fa-briefcase mr-2.5 text-primary"></i>
                                    Chef d'entreprise ?
                                </label>
                                <select
                                    id="chefEntreprise"
                                    value={chefEntreprise}
                                    onChange={(e) => setChefEntreprise(e.target.value === 'true')}
                                    className="form-input"
                                >
                                    <option value="false">Non</option>
                                    <option value="true">Oui</option>
                                </select>
                            </div>
                        
                            <div className="form-group">
                                <label htmlFor="active" className="form-label">
                                    <i className="fas fa-check-circle mr-2.5 text-primary"></i>
                                    Actif ?
                                </label>
                                <select
                                    id="active"
                                    value={active}
                                    onChange={(e) => setActive(e.target.value === 'true')}
                                    className="form-input"
                                >
                                    <option value="false">Non</option>
                                    <option value="true">Oui</option>
                                </select>
                            </div>
                            
                            <button 
                                type="submit" 
                                className="btn-primary w-full"
                            >
                                <i className="fas fa-user-plus mr-2"></i>
                                Inscrire
                            </button>
                        </form>
                    </div>
                </div>
            )}
            
            {showModal && (
                <div className="modal-overlay" onClick={hide}>
                    <div className="modal-content">
                        <button 
                            className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
                            onClick={hide}
                        >
                            ×
                        </button>
                        <div className="text-center">
                            <h2 className="text-2xl font-bold text-primary mb-4">Succès !</h2>
                            <p className="text-gray-700 mb-6">Inscription réussie !</p>
                            <button 
                                onClick={hide}
                                className="btn-primary"
                            >
                                Fermer
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};